import { requestJsonOrThrow } from "@/app/http";
import type {
  AddParentRequest,
  AdjustTimeRequest,
  CreateFamilyRequest,
  CreatePairingCodeRequest,
  DeleteFamilyRequest,
  FamilySummary,
  KidStatusSummary,
  PairingCodeSummary,
  SetTimeRequest,
} from "../contracts";

export function listFamilies() {
  return requestJsonOrThrow<{ families: FamilySummary[] }>("/api/services/screen-budget/v1/families");
}

export function listFamilyKids(familyId: number) {
  return requestJsonOrThrow<{ kids: KidStatusSummary[] }>(`/api/services/screen-budget/v1/families/${familyId}/kids`);
}

export function queueAdjustTime(kidId: number, body: AdjustTimeRequest) {
  return requestJsonOrThrow<{ message: unknown }>(`/api/services/screen-budget/v1/parents/kids/${kidId}/commands/adjust-time`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
}

export function queueSetTime(kidId: number, body: SetTimeRequest) {
  return requestJsonOrThrow<{ message: unknown }>(`/api/services/screen-budget/v1/parents/kids/${kidId}/commands/set-time`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
}

export function listAdminFamilies() {
  return requestJsonOrThrow<{ families: FamilySummary[] }>("/api/services/screen-budget/v1/admin/families");
}

export function createAdminFamily(body: CreateFamilyRequest) {
  return requestJsonOrThrow<{ family: FamilySummary }>("/api/services/screen-budget/v1/admin/families", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
}

export function deleteAdminFamily(familyId: number, body: DeleteFamilyRequest) {
  return requestJsonOrThrow<{ ok: boolean }>(`/api/services/screen-budget/v1/admin/families/${familyId}`, {
    method: "DELETE",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
}

export function listAdminParents(familyId: number) {
  return requestJsonOrThrow<{ parents: Array<{ userId: number; username: string; role: "owner" | "parent"; createdAt: string; updatedAt: string }> }>(
    `/api/services/screen-budget/v1/admin/families/${familyId}/parents`,
  );
}

export function addAdminParent(familyId: number, body: AddParentRequest) {
  return requestJsonOrThrow<{ ok: boolean }>(`/api/services/screen-budget/v1/admin/families/${familyId}/parents`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
}

export function removeAdminParent(familyId: number, userId: number) {
  return requestJsonOrThrow<{ ok: boolean }>(`/api/services/screen-budget/v1/admin/families/${familyId}/parents/${userId}`, {
    method: "DELETE",
  });
}

export function createAdminPairingCode(familyId: number, body: CreatePairingCodeRequest) {
  return requestJsonOrThrow<PairingCodeSummary>(`/api/services/screen-budget/v1/admin/families/${familyId}/pairing-codes`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
}

export function unenrollAdminKid(kidId: number) {
  return requestJsonOrThrow<{ ok: boolean }>(`/api/services/screen-budget/v1/admin/kids/${kidId}/unenroll`, {
    method: "POST",
  });
}

export function removeAdminKid(kidId: number) {
  return requestJsonOrThrow<{ ok: boolean; removed: boolean }>(`/api/services/screen-budget/v1/admin/kids/${kidId}`, {
    method: "DELETE",
  });
}
